import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Crown } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-yellow-500/20 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_elite-client-growth/artifacts/l293bfcb_Eliteiv%20logo%20No%20Number%20or%20website.png"
                alt="EliteIV Lounge"
                className="h-12 w-auto"
              />
            </div>
            <p className="text-sm text-gray-400">
              Elite mobile IV therapy delivered to your doorstep. Royal treatment for your wellness.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-yellow-400 font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-yellow-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-yellow-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-yellow-400 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-yellow-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-yellow-400 font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 text-yellow-400 mt-1 flex-shrink-0" />
                <a href="tel:727-503-2572" className="text-sm hover:text-yellow-400 transition-colors">
                  727-503-2572
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 text-yellow-400 mt-1 flex-shrink-0" />
                <a href="mailto:Vockmedical2006moe@gmail.com" className="text-sm hover:text-yellow-400 transition-colors break-all">
                  Vockmedical2006moe@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-yellow-400 mt-1 flex-shrink-0" />
                <span className="text-sm">
                  Serving Pinellas, Hillsborough & Pasco Counties — plus the greater Tampa Bay area
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-yellow-400 font-semibold mb-4">Service Hours</h3>
            <div className="text-sm space-y-2">
              <p>Mobile Service Available</p>
              <p className="text-yellow-400 font-medium">Call to Schedule</p>
              <p className="text-gray-400 mt-4">
                <Crown className="w-5 h-5 text-yellow-400 inline mr-2" />
                Premium Mobile IV Therapy
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-yellow-500/20 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} EliteIV Lounge. All rights reserved.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            Professional Mobile IV Therapy Services
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;